import { createFileRoute, redirect } from "@tanstack/react-router";

import { authUserSchema } from "@/modules/auth/schemes";
import { hasPermission } from "@/modules/auth/lib/permissions";
import { RepairCreatePage } from "@/modules/repairs/pages/RepairCreate.page";

export const Route = createFileRoute("/__authed/m/repairs/external/new")({
	beforeLoad({ context }) {
		const user = "user" in context ? context.user : undefined;

		if (!hasPermission(user, "create_external_repairs")) {
			throw redirect({ to: "/m/dashboard" });
		}
	},
	component: RouteComponent,
});

function RouteComponent() {
	const context = Route.useRouteContext();
	const rawUser =
		context && typeof context === "object" && "user" in context ? context.user : undefined;
	const parsedUser = authUserSchema.safeParse(rawUser);
	const user = parsedUser.success ? parsedUser.data : undefined;

	return <RepairCreatePage mode="external" externalClientId={user?.personId} />;
}
